import React from "react";
import { useEffect } from "react";
import Footer from "../components/footer";
import NavbarHome from "../components/navbar-home";
import GaleryCorouselContent from "../pages/Galerys/galery-corousel-content";
import GaleryCorouselJumbotron from "../pages/Galerys/galery-corousel-jumbotron";

export default function GaleryCorousel() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <NavbarHome />
      <GaleryCorouselJumbotron />
      <GaleryCorouselContent />
      <Footer />
    </>
  );
}
